import { useEffect, useState } from "react";
import axios from "axios";
import { API } from "@/lib/api";

export function useStationStatus(interval = 3000) {
  const [status, setStatus] = useState(null);
  const [elapsed, setElapsed] = useState(0);
  const [syncAt, setSyncAt] = useState(0);

  useEffect(() => {
    let alive = true;
    const load = async () => {
      try {
        const t0 = performance.now();
        const { data } = await axios.get(`${API}/station/status`);
        if (!alive) return;
        setSyncAt((t0 + performance.now()) / 2);
        setStatus(data);
        setElapsed(data.now_playing?.elapsed || 0);
      } catch {}
    };
    load();
    const t = setInterval(load, interval);
    const tick = setInterval(() => setElapsed((e) => e + 0.5), 500);
    return () => { alive = false; clearInterval(t); clearInterval(tick); };
  }, [interval]);

  return { status, elapsed, syncAt };
}
